// Get All Locations
export const GET_STATE_LANDMARK_REQUEST = 'GET_STATE_LANDMARK_REQUEST';
export const GET_STATE_LANDMARK_SUCCESS = 'GET_STATE_LANDMARK_SUCCESS';
export const GET_STATE_LANDMARK_FAILURE = 'GET_STATE_LANDMARK_FAILURE';
export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST';
export const GET_UNITS_FAILURE = 'GET_UNITS_FAILURE';
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
